/**
 * Water Report Popup — multi-step v4
 * States: wheel → form → done
 */
(function() {
  'use strict';

  const CONFIG = window.WaterReportConfig;
  if (!CONFIG) {
    console.error('Water Report Popup: Configuration not found.');
    return;
  }

  // Wheel segment labels, per market — English is the default for
  // anything not listed (UK/US/AU), matching the rest of the file's
  // translation approach.
  var WHEEL_LABELS = {
    FR: { win: 'RAPPORT|OFFERT', lose: 'PERDU' },
    DE: { win: 'BERICHT|GRATIS', lose: 'VERLOREN' },
  };

  function buildSegments(mkt) {
    var labels = WHEEL_LABELS[mkt] || { win: 'FREE|REPORT', lose: 'TRY|AGAIN' };
    var segments = [];
    for (var i = 0; i < 8; i++) {
      var isWin = i % 2 === 0;
      segments.push({
        label: isWin ? labels.win : labels.lose,
        prize: isWin ? 'report' : null,
        color: isWin ? 'blue' : 'white',
      });
    }
    return segments;
  }

  // Wheel segments — winning index 2 (FREE REPORT). Populated by
  // buildSegments(market) inside init(), once the market is known;
  // defaults to the English labels until then.
  var SEGMENTS = buildSegments(null);
  var SEG_ANG = 360 / SEGMENTS.length;
  var WINNING_INDEX = 0; // first blue segment

  // ── Translations ─────────────────────────────────────────────────────
  // English (the markup's own text) is the implicit default — nothing is
  // applied for markets not listed here, so UK/US/AU render exactly the
  // HTML already in the Liquid snippet, untouched.
  var TRANSLATIONS = {
    FR: {
      close_label: 'Fermer',
      spin_button: 'TOURNER',
      wheel_kicker: '50 000+ foyers testés',
      wheel_title: 'Tentez votre chance.',
      wheel_desc: 'Tournez la roue pour débloquer votre rapport d’eau personnalisé gratuit — d’une valeur de 49 €. Un tour, sans engagement.',
      wheel_legal: 'Un tour par visiteur. Sans obligation d’achat.',
      privacy_link: 'Politique de confidentialité',
      form_kicker: 'Vous avez gagné un rapport d’eau gratuit !',
      form_title: 'Réclamez votre rapport d’eau <span class="wr-popup-title__free">gratuit</span><br><span class="wr-popup-title__old">normalement 49 €</span>',
      form_desc: 'Indiquez vos coordonnées et nous vous enverrons votre analyse d’eau complète directement par e-mail.',
      email_placeholder: 'Votre adresse e-mail',
      zipcode_placeholder: 'Votre code postal (ex. 75001)',
      form_submit: 'Réclamer mon rapport gratuit &rarr;',
      form_legal: 'Jamais de spam. Désabonnement à tout moment.',
      done_eyebrow: 'Rapport réclamé',
      done_headline: 'Vérifiez votre<br>boîte mail.',
      done_sub: 'Nous analysons votre code postal. Votre rapport d’eau personnalisé arrivera dans votre boîte mail dans quelques minutes.',
      done_applied: 'Rapport gratuit en cours d’envoi',
      done_continue: 'Continuer mes achats',
      done_legal: 'Livraison gratuite · Satisfait ou remboursé pendant 60 jours',
      right_caption: 'Une analyse complète de votre eau du robinet<small>Basée sur des milliers d’échantillons.</small>',
    },
    DE: {
      close_label: 'Schließen',
      spin_button: 'DREHEN',
      wheel_kicker: '50.000+ getestete Haushalte',
      wheel_title: 'Versuchen Sie Ihr Glück.',
      wheel_desc: 'Drehen Sie, um Ihren kostenlosen, personalisierten Wasserbericht freizuschalten — im Wert von 49 €. Eine Drehung, keine Verpflichtung.',
      wheel_legal: 'Eine Drehung pro Besucher. Kein Kauf erforderlich.',
      privacy_link: 'Datenschutzrichtlinie',
      form_kicker: 'Sie haben einen kostenlosen Wasserbericht gewonnen!',
      form_title: 'Sichern Sie sich Ihren <span class="wr-popup-title__free">kostenlosen</span> Wasserbericht<br><span class="wr-popup-title__old">normalerweise 49 €</span>',
      form_desc: 'Geben Sie Ihre Daten ein und wir senden Ihnen Ihre vollständige Wasseranalyse direkt per E-Mail.',
      email_placeholder: 'Ihre E-Mail-Adresse',
      zipcode_placeholder: 'Ihre Postleitzahl (z. B. 10115)',
      form_submit: 'Meinen kostenlosen Bericht anfordern &rarr;',
      form_legal: 'Niemals Spam. Jederzeit abbestellbar.',
      done_eyebrow: 'Bericht angefordert',
      done_headline: 'Prüfen Sie Ihr<br>Postfach.',
      done_sub: 'Wir analysieren jetzt Ihre Postleitzahl. Ihr personalisierter Wasserbericht landet in wenigen Minuten in Ihrem Postfach.',
      done_applied: 'Kostenloser Bericht ist unterwegs',
      done_continue: 'Weiter einkaufen',
      done_legal: 'Kostenlose Lieferung · 60 Tage Geld-zurück-Garantie',
      right_caption: 'Eine vollständige Analyse Ihres Leitungswassers<small>Basierend auf Tausenden von Proben.</small>',
    }
  };

  // AU keeps the English copy (no FR/DE-style translation requested) but
  // the markup's default £49 (GBP) is wrong for that market — swap the
  // currency symbol only, nothing else about the text changes.
  var CURRENCY_ONLY = {
    AUS: { wheel_desc: 'Spin to unlock your free personalised water report — worth $49. One spin, zero strings.',
           form_title: 'Claim your <span class="wr-popup-title__free">Free</span> Water Report<br><span class="wr-popup-title__old">normally $49</span>' },
  };

  function applyTranslations(mkt) {
    var dict = TRANSLATIONS[mkt] || CURRENCY_ONLY[mkt];
    if (!dict) return; // UK/US (or anything unmapped) keep the English markup as-is

    Object.keys(dict).forEach(function(key) {
      var value = dict[key];
      var textEls = overlay.querySelectorAll('[data-i18n="' + key + '"]');
      for (var i = 0; i < textEls.length; i++) textEls[i].textContent = value;

      var htmlEls = overlay.querySelectorAll('[data-i18n-html="' + key + '"]');
      for (var j = 0; j < htmlEls.length; j++) htmlEls[j].innerHTML = value;

      var placeholderEls = overlay.querySelectorAll('[data-i18n-placeholder="' + key + '"]');
      for (var k = 0; k < placeholderEls.length; k++) placeholderEls[k].setAttribute('placeholder', value);

      var ariaLabelEls = overlay.querySelectorAll('[data-i18n-aria-label="' + key + '"]');
      for (var m = 0; m < ariaLabelEls.length; m++) ariaLabelEls[m].setAttribute('aria-label', value);
    });
  }

  var isPostcodeValid = false;
  var validationTimeout = null;
  var popupSessionId = null;
  var impressionTracked = false;
  var spinning = false;
  var currentRotation = 0;

  var overlay, modal, closeBtn, form, submitBtn, zipcodeInput, market, marketStorageKey;
  var wheelEl, wheelSvg, hubEl, confettiEl;

  // ── Wheel ────────────────────────────────────────────────────────────

  function buildWheel() {
    var blue = '#2764FF';
    var ns = 'http://www.w3.org/2000/svg';
    wheelSvg.innerHTML = '';

    for (var i = 0; i < SEGMENTS.length; i++) {
      var startAng = -90 + i * SEG_ANG;
      var endAng = startAng + SEG_ANG;
      var r = 100;
      var x1 = r * Math.cos(startAng * Math.PI / 180);
      var y1 = r * Math.sin(startAng * Math.PI / 180);
      var x2 = r * Math.cos(endAng * Math.PI / 180);
      var y2 = r * Math.sin(endAng * Math.PI / 180);
      var d = 'M0,0 L' + x1 + ',' + y1 + ' A' + r + ',' + r + ' 0 0,1 ' + x2 + ',' + y2 + ' Z';
      var fill = SEGMENTS[i].color === 'blue' ? blue : '#FFFFFF';
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      p.setAttribute('fill', fill);
      p.setAttribute('stroke', blue);
      p.setAttribute('stroke-width', '1.5');
      wheelSvg.appendChild(p);
    }

    for (var j = 0; j < SEGMENTS.length; j++) {
      var centerAng = -90 + j * SEG_ANG + SEG_ANG / 2;
      var rLabel = 68;
      var cx = rLabel * Math.cos(centerAng * Math.PI / 180);
      var cy = rLabel * Math.sin(centerAng * Math.PI / 180);
      var seg = SEGMENTS[j];
      var color = seg.color === 'blue' ? '#FFFFFF' : blue;
      var g = document.createElementNS(ns, 'g');
      g.setAttribute('transform', 'translate(' + cx + ',' + cy + ') rotate(' + (centerAng + 90) + ')');
      var txt = document.createElementNS(ns, 'text');
      txt.setAttribute('text-anchor', 'middle');
      txt.setAttribute('dominant-baseline', 'middle');
      txt.setAttribute('fill', color);
      txt.setAttribute('font-family', 'Inter, sans-serif');
      txt.setAttribute('font-weight', '600');
      txt.setAttribute('letter-spacing', '0.5');
      var parts = seg.label.split('|');
      if (parts.length > 1) {
        txt.setAttribute('font-size', '10');
        var line1 = document.createElementNS(ns, 'tspan');
        line1.setAttribute('x', '0'); line1.setAttribute('dy', '-6');
        line1.textContent = parts[0];
        var line2 = document.createElementNS(ns, 'tspan');
        line2.setAttribute('x', '0'); line2.setAttribute('dy', '13');
        line2.textContent = parts[1];
        txt.appendChild(line1); txt.appendChild(line2);
      } else {
        // Single-line labels: shrink the font for longer words so they
        // don't overflow the (narrow) wheel segment — e.g. "VERLOREN" (DE)
        // vs "SPIN" (EN). 6 chars fits at the normal size; beyond that,
        // scale down gradually.
        var fontSize = seg.label.length > 6 ? Math.max(6, 10 - (seg.label.length - 6)) : 10;
        txt.setAttribute('font-size', String(fontSize));
        txt.textContent = seg.label;
      }
      g.appendChild(txt);
      wheelSvg.appendChild(g);
    }
  }

  function spin() {
    if (spinning) return;
    spinning = true;
    hubEl.classList.remove('is-pulse');

    var segCenterFromTop = WINNING_INDEX * SEG_ANG + SEG_ANG / 2;
    var extraSpins = 6;
    var finalRotation = extraSpins * 360 - segCenterFromTop + (Math.random() * (SEG_ANG * 0.4) - SEG_ANG * 0.2);

    currentRotation += finalRotation;
    wheelEl.style.transform = 'rotate(' + currentRotation + 'deg)';

    setTimeout(function() {
      fireConfetti();
      setState('form');
      spinning = false;
    }, 5000);
  }

  function fireConfetti() {
    if (!confettiEl) return;
    var colors = ['#2764FF', '#7098FF', '#E1EAFF', '#A7C0FF', '#C9FF00'];
    confettiEl.innerHTML = '';
    for (var i = 0; i < 40; i++) {
      var s = document.createElement('span');
      s.style.left = (Math.random() * 100) + '%';
      s.style.background = colors[Math.floor(Math.random() * colors.length)];
      s.style.animationDuration = (2.2 + Math.random() * 1.8) + 's';
      s.style.animationDelay = (Math.random() * 0.4) + 's';
      s.style.width = (4 + Math.random() * 4) + 'px';
      s.style.height = (6 + Math.random() * 8) + 'px';
      s.style.opacity = (0.7 + Math.random() * 0.3).toFixed(2);
      s.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
      confettiEl.appendChild(s);
    }
    setTimeout(function() { confettiEl.innerHTML = ''; }, 4500);
  }

  function setState(name) {
    var states = overlay.querySelectorAll('[data-wr-state]');
    for (var i = 0; i < states.length; i++) {
      states[i].classList.toggle('is-active', states[i].getAttribute('data-wr-state') === name);
    }
  }

  // ── Postcode validation ──────────────────────────────────────────────

  async function validatePostcode(postcode) {
    var cleanPostcode = postcode.trim().replace(/\s+/g, '');
    // Minimum length before even attempting validation — AU postcodes are
    // only 4 digits (e.g. "2000"), so the generic 5-char floor used for
    // UK/US/FR/DE would reject a complete, valid AU postcode outright.
    var minLength = market === 'AUS' ? 4 : 5;
    if (cleanPostcode.length < minLength) return { valid: false, message: '' };

    if (market === 'US') {
      var usZipPattern = /^[0-9]{5}(-[0-9]{4})?$/;
      var valid = usZipPattern.test(cleanPostcode);
      return { valid: valid, message: valid ? '' : 'Invalid US ZIP code' };
    }

    if (market === 'FR' || market === 'DE') {
      // No live validation API wired up for these markets yet — a plain
      // 5-digit format check is enough for now (same approach as US above).
      var euPostcodeValid = /^[0-9]{5}$/.test(cleanPostcode);
      var euMsg = market === 'FR' ? 'Code postal invalide' : 'Ungültige Postleitzahl';
      return { valid: euPostcodeValid, message: euPostcodeValid ? '' : euMsg };
    }

    if (market === 'AUS') {
      var auPostcodeValid = /^[0-9]{4}$/.test(cleanPostcode);
      return { valid: auPostcodeValid, message: auPostcodeValid ? '' : 'Invalid postcode' };
    }

    try {
      var response = await fetch(CONFIG.postcodeApiUrl + '/' + encodeURIComponent(cleanPostcode) + '/validate');
      var data = await response.json();
      return { valid: data.result === true, message: data.result === true ? '' : 'Invalid UK postcode' };
    } catch (error) {
      return { valid: false, message: 'Unable to validate postcode' };
    }
  }

  function updatePostcodeUI(state) {
    if (!zipcodeInput) return;
    var formGroup = zipcodeInput.closest('.wr-form-group');
    var errorEl = formGroup && formGroup.querySelector('.wr-postcode-error');
    zipcodeInput.classList.remove('is-valid', 'is-invalid', 'is-validating');

    if (state === 'validating') {
      zipcodeInput.classList.add('is-validating');
      if (errorEl) errorEl.textContent = '';
    } else if (state === 'valid') {
      zipcodeInput.classList.add('is-valid');
      if (errorEl) errorEl.textContent = '';
    } else if (state === 'invalid') {
      zipcodeInput.classList.add('is-invalid');
    } else {
      if (errorEl) errorEl.textContent = '';
    }

    updateSubmitButton();
  }

  function showPostcodeError(message) {
    if (!zipcodeInput) return;
    var formGroup = zipcodeInput.closest('.wr-form-group');
    var errorEl = formGroup && formGroup.querySelector('.wr-postcode-error');
    if (!errorEl && formGroup) {
      errorEl = document.createElement('span');
      errorEl.className = 'wr-postcode-error';
      formGroup.appendChild(errorEl);
    }
    if (errorEl) errorEl.textContent = message;
  }

  function handlePostcodeInput() {
    isPostcodeValid = false;
    if (validationTimeout) clearTimeout(validationTimeout);
    var value = (zipcodeInput && zipcodeInput.value.trim()) || '';
    var minLength = market === 'AUS' ? 4 : 5;
    if (value.length < minLength) { updatePostcodeUI('neutral'); return; }
    updatePostcodeUI('validating');
    validationTimeout = setTimeout(async function() {
      var result = await validatePostcode(value);
      isPostcodeValid = result.valid;
      if (result.valid) {
        updatePostcodeUI('valid');
      } else {
        updatePostcodeUI('invalid');
        if (result.message) showPostcodeError(result.message);
      }
    }, CONFIG.debounceDelay);
  }

  function updateSubmitButton() {
    if (!submitBtn) return;
    var emailInput = form && form.querySelector('#wr-email');
    var emailValid = (emailInput && emailInput.validity && emailInput.validity.valid) || false;
    var canSubmit = emailValid && isPostcodeValid;
    submitBtn.disabled = !canSubmit;
    submitBtn.classList.toggle('is-disabled', !canSubmit);
  }

  // ── Session / tracking ───────────────────────────────────────────────

  function generateUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getPopupSessionId() {
    if (popupSessionId) return popupSessionId;
    try {
      var existing = localStorage.getItem(CONFIG.sessionIdKey);
      if (existing) { popupSessionId = existing; return popupSessionId; }
    } catch (e) {}
    popupSessionId = generateUUID();
    try { localStorage.setItem(CONFIG.sessionIdKey, popupSessionId); } catch (e) {}
    return popupSessionId;
  }

  async function trackPopupImpression() {
    if (impressionTracked) return;
    try { if (sessionStorage.getItem(CONFIG.impressionTrackedKey) === 'true') return; } catch (e) {}
    var sessionId = getPopupSessionId();
    try {
      await fetch(CONFIG.supabaseImpressionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + CONFIG.supabaseAnonKey, 'apikey': CONFIG.supabaseAnonKey },
        body: JSON.stringify({ popup_session_id: sessionId })
      });
      impressionTracked = true;
      try { sessionStorage.setItem(CONFIG.impressionTrackedKey, 'true'); } catch (e) {}
    } catch (err) { console.error('[WR] impression tracking failed:', err); }
  }

  async function trackFormSubmission(email, sessionId) {
    try {
      await fetch(CONFIG.supabaseFormSubmissionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + CONFIG.supabaseAnonKey, 'apikey': CONFIG.supabaseAnonKey },
        body: JSON.stringify({ popup_session_id: sessionId, email: email })
      });
    } catch (err) { console.error('[WR] submission tracking failed:', err); }
  }

  // ── Popup show/hide ──────────────────────────────────────────────────

  function showPopup() {
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    getPopupSessionId();
    trackPopupImpression();
    isPostcodeValid = false;
    updateSubmitButton();
    document.addEventListener('keydown', handleKeydown);
  }

  function hidePopup() {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleKeydown);
    try { sessionStorage.setItem(marketStorageKey, 'true'); } catch (e) {}
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') hidePopup();
  }

  // ── Form submit ──────────────────────────────────────────────────────

  async function handleSubmit(e) {
    e.preventDefault();

    var emailInput = form.querySelector('#wr-email');
    var phoneInput = form.querySelector('#wr-phone');
    if (!emailInput || !phoneInput || !zipcodeInput) return;
    if (!isPostcodeValid) {
      var invalidMsg =
        market === 'US' ? 'Please enter a valid ZIP code' :
        market === 'FR' ? 'Veuillez saisir un code postal valide' :
        market === 'DE' ? 'Bitte geben Sie eine gültige Postleitzahl ein' :
        market === 'AUS' ? 'Please enter a valid postcode' :
        'Please enter a valid UK postcode';
      showPostcodeError(invalidMsg);
      return;
    }

    var data = {
      email: emailInput.value.trim(),
      phone: phoneInput.value.trim(),
      zipcode: zipcodeInput.value.trim(),
      popup_session_id: getPopupSessionId(),
      source: 'popup',
      market: form.dataset.market || 'UK'
    };

    if (!data.email || !data.zipcode) return;

    try { localStorage.setItem(marketStorageKey + '_submitted', 'true'); } catch (e) {}
    try { sessionStorage.setItem(marketStorageKey, 'true'); } catch (e) {}

    // Switch to confirmation state
    setState('done');
    fireConfetti();

    // Fire-and-forget background calls
    trackFormSubmission(data.email, data.popup_session_id);
    var webhookUrl = (market === 'US' && CONFIG.webhookUrlUS) ? CONFIG.webhookUrlUS : CONFIG.webhookUrl;
    fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).catch(function(err) { console.error('[WR] webhook error:', err); });
  }

  // ── Market check ─────────────────────────────────────────────────────

  function shouldShowPopup() {
    try {
      if (localStorage.getItem(marketStorageKey + '_submitted')) return false;
      if (sessionStorage.getItem(marketStorageKey)) return false;
    } catch (e) {}
    return true;
  }

  async function checkMarketEnabled(mkt) {
    try {
      var resp = await fetch('/apps/water-report?action=market-status&market=' + encodeURIComponent(mkt));
      if (!resp.ok) return true;
      var data = await resp.json();
      return data.enabled !== false;
    } catch (err) { return true; }
  }

  // ── Init ─────────────────────────────────────────────────────────────

  function init() {
    overlay      = document.getElementById('water-report-overlay');
    modal        = overlay && overlay.querySelector('.wr-popup-modal');
    closeBtn     = overlay && overlay.querySelector('.wr-popup-close');
    form         = document.getElementById('wr-popup-form');
    submitBtn    = form && form.querySelector('.wr-form-submit');
    zipcodeInput = form && form.querySelector('#wr-zipcode');
    wheelEl      = overlay && overlay.querySelector('[data-wr-wheel]');
    wheelSvg     = overlay && overlay.querySelector('[data-wr-wheel-svg]');
    hubEl        = overlay && overlay.querySelector('[data-wr-spin]');
    confettiEl   = overlay && overlay.querySelector('[data-wr-confetti]');

    if (!overlay || !modal || !form) {
      console.warn('[WR Popup] Required elements not found — aborting');
      return;
    }

    var shopifyCountry = (typeof Shopify !== 'undefined' && Shopify.country) ? Shopify.country : null;

    // ── Internal test override ────────────────────────────────────────
    // ?wr_test=1 in the URL forces the water-report popup open immediately
    // — bypassing the show-delay/once-per-session gating below (but NOT the
    // market-enabled toggle — see checkMarketEnabled/isTestMode usage near
    // the bottom of init()).
    var isTestMode = false;
    try {
      isTestMode = new URLSearchParams(window.location.search).get('wr_test') === '1';
    } catch (e) {}

    // Only these 5 Shopify countries are actually built/tested markets.
    // Anyone else (Poland, Italy, Spain, ...) never sees the popup at all —
    // there is no sensible fallback market for a country we haven't built
    // postcode validation, legal limits, or an intl data source for.
    var COUNTRY_TO_MARKET = { GB: 'UK', US: 'US', DE: 'DE', FR: 'FR', AU: 'AUS' };
    if (!isTestMode && (!shopifyCountry || !COUNTRY_TO_MARKET[shopifyCountry])) {
      console.warn('[WR Popup] Country not supported:', shopifyCountry);
      return;
    }

    // Market is derived from the active Shopify market/country (test mode
    // without a mappable country falls back to 'UK' so ?wr_test=1 always
    // previews *something* even from an unmapped storefront). Beyond this
    // allow-list, the "Popup visibility by market" toggles in the admin
    // dashboard (MarketToggle table, checked via checkMarketEnabled below)
    // are what decides whether the popup shows for a given supported market.
    market = COUNTRY_TO_MARKET[shopifyCountry] || 'UK';
    form.dataset.market = market;
    marketStorageKey = CONFIG.storageKey + '_' + market.toLowerCase();

    // Translate the popup's static copy for FR/DE (UK/US/AU keep the
    // English markup untouched — see TRANSLATIONS/applyTranslations above).
    applyTranslations(market);

    if (market === 'US' && zipcodeInput) {
      zipcodeInput.placeholder = 'Your ZIP code (e.g. 10001)';
      zipcodeInput.pattern = '[0-9]{5}(-[0-9]{4})?';
      zipcodeInput.maxLength = 10;
    } else if ((market === 'FR' || market === 'DE') && zipcodeInput) {
      // 5-digit postcodes — the placeholder text is already set by
      // applyTranslations() above (zipcode_placeholder); only the
      // validation pattern/length need adjusting here.
      zipcodeInput.pattern = '[0-9]{5}';
      zipcodeInput.maxLength = 5;
    } else if (market === 'AUS' && zipcodeInput) {
      // 4-digit postcodes (e.g. 2000 for Sydney) — English copy stays as-is
      // (no AU translation requested), just the placeholder/pattern.
      zipcodeInput.placeholder = 'Your postcode (e.g. 2000)';
      zipcodeInput.pattern = '[0-9]{4}';
      zipcodeInput.maxLength = 4;
    }

    // Build wheel (segment labels match the market's language)
    SEGMENTS = buildSegments(market);
    if (wheelEl && wheelSvg && hubEl) {
      buildWheel();
      hubEl.addEventListener('click', spin);
    }

    // Close handlers
    closeBtn && closeBtn.addEventListener('click', hidePopup);

    // Click outside the modal (on the overlay backdrop) closes it too
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) hidePopup();
    });

    var doneClose = document.getElementById('wr-done-close');
    if (doneClose) doneClose.addEventListener('click', hidePopup);

    // Form handlers
    form.addEventListener('submit', handleSubmit);
    zipcodeInput && zipcodeInput.addEventListener('input', handlePostcodeInput);
    var emailInput = form.querySelector('#wr-email');
    emailInput && emailInput.addEventListener('input', updateSubmitButton);
    updateSubmitButton();

    // Excluded pages (still respected in test mode — this is about which
    // pages the popup script runs on at all, not the country/market gate)
    var path = window.location.pathname;
    if (path.indexOf('/pages/quizz-funnel') !== -1 ||
        path.indexOf('/apps/quizz-funnel') !== -1 ||
        path.indexOf('/pages/analyze-my-water') !== -1) {
      return;
    }

    if (isTestMode) {
      // Skip the once-per-session gate, the market-enabled toggle check,
      // and the show delay — open immediately regardless of the market's
      // dashboard toggle state, so a market can be previewed before it's
      // switched on for real visitors. Only the person testing (who added
      // ?wr_test=1) ever sees this path.
      console.info('[WR Popup] Test mode — forcing popup open for market:', market);
      showPopup();
      return;
    }

    if (shouldShowPopup()) {
      checkMarketEnabled(market).then(function(enabled) {
        if (!enabled) return;
        setTimeout(showPopup, CONFIG.showDelay);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
